export const ModernChicData = {
  defaultData: true,
  eventType: 1,
  bannerPhoto:
    "https://res.cloudinary.com/dxedclcqu/image/upload/v1722675908/static-assets/pexels-tkdhamu-14961039_tgibek.jpg",
  phone: "123-456-7890",
  homeAddress: "Marine Lines, Mumbai, India",
  events: [
    {
      name: "Haldi Ceremony",
      dateAndTime: {
        date: "Tuesday, 17 Sep. 2025",
        time: "04:00 PM",
        dateStringTZ: "2024-09-17T10:30:00.000+00:00",
      },
      venue: "The Taj Mahal Palace, Mumbai, India",
      theme: "Flower shower",
      photo:
        "https://res.cloudinary.com/dxedclcqu/image/upload/v1720252677/static-assets/haldi_mqk4mw.svg",
    },
    {
      name: "Wedding Ceremony",
      dateAndTime: {
        date: "Tuesday, 17 Sep. 2025",
        time: "04:00 PM",
        dateStringTZ: "2024-09-17T10:30:00.000+00:00",
      },
      venue: "The Taj Mahal Palace, Mumbai, India",
      theme: "Pastels",
      photo:
        "https://res.cloudinary.com/dxedclcqu/image/upload/v1720252678/static-assets/card_q7crio.svg",
    },
    {
      name: "Reception",
      dateAndTime: {
        date: "Tuesday, 17 Sep. 2025",
        time: "04:00 PM",
        dateStringTZ: "2024-09-17T10:30:00.000+00:00",
      },
      venue: "The Taj Mahal Palace, Mumbai, India",
      theme: "Bollywood",
      photo:
        "https://res.cloudinary.com/dxedclcqu/image/upload/v1720252677/static-assets/toast_o7tsgn.svg",
    },
  ],
  bride: {
    name: "Suwarna Dugal",
    motherName: "Radha Dugal",
    fatherName: "Anit Dugal",
    grandFatherName: "Shyamlal Dugal",
    grandMotherName: "Manorama Dugal",
    nativePlace: "Jaipur, Rajasthan",
    photo:
      "https://res.cloudinary.com/dxedclcqu/image/upload/c_fill,w_450,h_450,g_auto/v1722699803/static-assets/pexels-enginakyurt-1642228_m3ulyz.jpg",
    about:
      "Suwarna is a landscape architect with a passion for creating serene, beautiful spaces.",
    phone: "2423534534",
  },
  groom: {
    name: "Ishaan Mehta",
    motherName: "Hema Mehta",
    fatherName: "Kushal Mehta",
    nativePlace: "Udaipur, Rajasthan",
    photo:
      "https://res.cloudinary.com/dxedclcqu/image/upload/c_fill,w_450,h_450,g_auto/v1722700721/static-assets/pexels-italo-melo-881954-2379004_zwlgyq.jpg",
    about:
      "Ishaan is an accomplished software engineer known for his analytical mind and innovative spirit.",
    phone: "2423534534",
  },
  quote:
    "Love is the essence that binds two hearts, and marriage is the celebration that brings those hearts together forever.",
  quotePhoto:
    "https://res.cloudinary.com/dxedclcqu/image/upload/v1722677799/static-assets/pexels-jonathanborba-2950331_stfmwy.jpg",
  venue: {
    address: "The Taj Mahal Palace, Mumbai, India",
    latitude: "18.9217",
    longitude: "72.8332",
    phone: "123-456-7890",
  },
  bestComplimentsFrom:
    "Mr. Dharma Dugal - Mrs. Sunita Dugal,\nMr. Harsh Dugal - Mrs. Uma Dugal,\nMr. Kalyan Dugal - Mrs. Navya Dugal,\nMr. Jitendra Dugal - Mrs. Kalpana Dugal\n(Bhaiya - Bhabhi)",
  invitingWithGreatPleasure:
    "Mr. Vivan Mehta - Mrs. Aashita Mehta,\nMr. Rajesh Mehta - Mrs. Malati Mehta,\nMr. Amit Doshi - Mrs. Nupur Doshi,\nMr. Ayan Doshi - Mrs. Shreya Doshi",
  warmRegards:
    "Mr. Vijay Ahuja - Mrs. Namrata Ahuja,\nMr. Narendra Ahuja - Mrs. Supriya Ahuja,\nMr. Sudhir Ahuja - Mrs. Dipti Ahuja,\nMr. Anupam Ahuja - Mrs. Sangeeta Jain",
};
